<template>
    <div id="ChatbotAiPrompt">
        <div>
            <h1>Chatbot Ai Prompt</h1>
            <p>
                Artificial intelligence learns and determines how it should behave by being given instructions about a
                specific task or problem using the 'prompt' feature.
            </p>
            <a-textarea
                v-model="promptText"
                placeholder="Enter the prompt"
                :auto-size="{ minRows: 2, maxRows: 5 }"
                style="height: 500px"
                :disabled="isDisabled"
            />
            <div class="settings-btn">
                <SupsisButton
                    ghost
                    @click="clearPrompt"
                >
                    Cancel
                </SupsisButton>
                <SupsisButton
                    primary
                    @click="updatePrompt"
                    :disabled="isDisabled"
                >Save
                </SupsisButton>
            </div>
        </div>
        <hr>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import CommingSoonData from "../ComingSoon.vue";

export default {
    name: "ChatbotAiPrompt",
    components: {
        SupsisButton,
        CommingSoonData,
    },
    props: {
        stroyId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            promptText: "Sen bir websitenin çağrı merkezinde çalışan müşterilere cevap veren bir canlı destek personelisin. Bilmediğin şeyler hakkında cevap verme.  Seninle websitesine gelen ziyaretciler konuşacak.",
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
        isDisabled() {
            const story = this.stories.find((story) => story.id === this.stroyId);
            return !(story && story.ai);
        },

    },
    mounted() {
        const story = this.stories.find((story) => story.id === this.stroyId);
        if (story && story.ai && story.ai.prompt) {
            this.promptText = story.ai.prompt;
        }
    },
    methods: {
        ...mapActions({
            updateStorySingleKey: "CB/updateStorySingleKey",
        }),
        updatePrompt() {
            this.updateStorySingleKey({
                id: this.stroyId,
                key: "ai.prompt",
                value: this.promptText,
            });
            this.$message.success("Prompt updated successfully");
        },
        clearPrompt() {
            this.promptText = "";
        },
    },
};
</script>
<style lang="scss" scoped>
#ChatbotAiPrompt {
    margin: 30px;

    .settings-btn {
        display: flex;
        gap: 20px;
        float: right;
        margin: 30px;
    }
}
</style>
